export const selectionRoutes = [
    {
        path: '/product',
        name: 'ProductSelect',
        exact: true,
        component: () => import('@/modules/product/views/ProductSelect.vue'),
        meta: {
            breadcrumb: [{ label: 'Product Selection' }],
        },
    },
];
